import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// European Languages
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import pl from './locales/pl.json';

// Indian Languages (UK market focus)
import hi from './locales/hi.json';
import pa from './locales/pa.json';  // Punjabi
import gu from './locales/gu.json';  // Gujarati
import bn from './locales/bn.json';  // Bengali
import ta from './locales/ta.json';  // Tamil
import ur from './locales/ur.json';  // Urdu

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  pt: { translation: pt },
  pl: { translation: pl },
  hi: { translation: hi },
  pa: { translation: pa },
  gu: { translation: gu },
  bn: { translation: bn },
  ta: { translation: ta },
  ur: { translation: ur },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
